import(/* webpackMode: "eager" */ "/home/quara/dev/presentgatan.se/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/quara/dev/presentgatan.se/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/quara/dev/presentgatan.se/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/home/quara/dev/presentgatan.se/src/app/components/Footer/footer.module.scss");
;
import(/* webpackMode: "eager" */ "/home/quara/dev/presentgatan.se/src/app/components/Generator/generator.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/quara/dev/presentgatan.se/src/app/components/Underline/underline.js");
;
import(/* webpackMode: "eager" */ "/home/quara/dev/presentgatan.se/src/app/home.module.scss");
